import apiClient from '../utils/apiClient';

export const employeeTimeAllocationApi = {
  getAll: async (params) => {
    const response = await apiClient.get('/employee-time-allocation', { params });
    return response.data;
  },

  getByEmployee: async (employeeId) => {
    const response = await apiClient.get(`/employee-time-allocation/${employeeId}`);
    return response.data;
  },

  getMissing: async (weekStart) => {
    const response = await apiClient.get(`/employee-time-allocation/missing/${weekStart}`);
    return response.data;
  },

  create: async (data) => {
    const response = await apiClient.post('/employee-time-allocation', data);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiClient.delete(`/employee-time-allocation/${id}`);
    return response.data;
  }
};
